import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Modal from "components/global/modal";
import { FaTimes } from "react-icons/fa";
import Slider from "react-slick";
import "./styles.css";
import Zoom from "./zoom";
function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                transform: "scale(2.4)",
                marginRight: -10,
            }}
            onClick={onClick}
        />
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                display: "block",
                transform: "scale(2.4)",
                marginLeft: -10,
            }}
            onClick={onClick}
        />
    );
}

export default function ImageGallery({ hide, ...props }) {
    const { media = [], button = {}, focus = 1, totalPhotos=0 } = props;

    const sliderRef = useRef();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentImage, setCurrentImage] = useState();
    const [isMobile, setIsMobile] = React.useState(false);
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

    const modalRef = useRef(null);
    const [modalHeight, setModalHeight] = useState(0);
    
    useLayoutEffect(() => {
    if (modalRef.current) {
        setModalHeight(modalRef.current.clientHeight-30);
    }
  }, []); // runs after first render
    

    React.useEffect(()=>{
        // const userAgent = window.navigator.userAgent;
        // const mobileDevices = /Mobi|Android|iPhone|Ipad/; 
        //setIsMobile(mobileDevices.test(userAgent)); 
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        setIsMobile(isMobile); 


        const updateHeight = () => {
            setViewportHeight(window.innerHeight); // Dynamically adjust height
            setViewportWidth(window.innerWidth); 
          };
        
          // Add listeners for resize and orientation change
          window.addEventListener("resize", updateHeight);
          window.addEventListener("orientationchange", updateHeight);
        
          return () => {
            window.removeEventListener("resize", updateHeight);
            window.removeEventListener("orientationchange", updateHeight);
          };
    },[])
    

    const settings = {
        className: `center min-h-[calc(100vh_-_5rem)] ${isMobile ? '3_1sm:min-h-[calc(100vh_-_2rem)]' : '3_1sm:min-h-[calc(98vh_-_2rem)]'} relative img-gallery`,
        dots: false,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => setCurrentIndex((prev) => next + 1),
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        // adaptiveHeight: true,
    };

    const onChange = (index) => {
        setCurrentIndex((prev) => index + 1);
        sliderRef.current.slickGoTo(index);
    };

    useEffect(() => {
        if (sliderRef.current) {
            setCurrentIndex(focus);
            sliderRef.current.slickGoTo(focus - 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focus, sliderRef.current]);

    useEffect(()=>{
       setCurrentImage(media[currentIndex - 1]?.media); 
    },[currentIndex,media]);

    const FileNameEllipsis = (filename, maxChars) => {
        if (filename.length <= maxChars) {
          return filename;
        } else {
          const ellipsis = "...";
          const truncatedFilename =
            filename.substring(0, maxChars - ellipsis.length) + ellipsis;
          return truncatedFilename;
        }
      };

    return (
        <>
        {
            isMobile  ?
            <div className="">
                <Modal
                    mainContainer="bg-black"
                    width="3_1sm:w-[calc(100%_-_12rem)] w-[calc(100%_-_1rem)] h-[90vh]"
                    contentClassName="rounded-lg overflow-auto custom-style"
                    wrapperClassName=" custom-style sm:my-0"
                    image_gallery={true}
                >
                    <div className="flex flex-row justify-between items-baseline">
                        <p className="text-base text-white font-bold text-title flex-1">
                            {/* {media.length}{" "}
                            {media.length > 1 ? "Photos" : "Photo"} */}
                            {currentIndex} of {totalPhotos}
                            <span className="text-sm text-white text-counter">
                                {(currentImage?.file_name || currentImage?.title) ? ` - ${FileNameEllipsis(currentImage?.file_name || currentImage?.title || "",35)}` : ""
                            }</span>
                        </p>
                        {/* <p className="text-sm text-white text-counter flex-1 ml-6">
                            {currentIndex} of {media.length}
                        </p> */}
                        {/* close */}
                        <div className="flex justify-end">
                            <button onClick={() => hide()} className="mr-4">
                                <FaTimes className="text-white text-sm" />
                            </button>
                        </div>
                    </div>
                    {button.url ? (
                        <Slider ref={sliderRef} {...settings} arrows={false}>
                            <div className="bg-black">
                                <img
                                    src={button.url}
                                    className="object-cove m-auto px-1"
                                    style={{ maxHeight: `${viewportHeight-30}px`,width: `${viewportWidth}px`}}
                                    alt="slider"
                                />
                            </div>
                        </Slider>
                    ) : (
                        <Slider ref={sliderRef} {...settings} arrows={false}>
                            {media.map((file, index) => {
                                return (
                                    <div key={index} className="bg-black flex justify-center flex-1">
                                        <Zoom isMobile={true}>
                                        {({resetTransform}) => (
                                            <div className="relative w-full h-[90svh] flex">
                                                <img
                                                    src={file.media.webp_url || file.media.url}
                                                    className="object-cover m-auto px-1"
                                                    style={{ opacity: 0, 
                                                        maxHeight: `${viewportHeight-50}px`,
                                                        // width: `${viewportWidth-4}px`,
                                                        // height:`${viewportHeight}px`,
                                                        transition: 'all 0.3s 0.25s', 
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                     }}
                                                    alt={`slider-${index}`}
                                                    draggable="false" 
                                                    onLoad={(e) => {
                                                        e.target.style.opacity = 1;
                                                        typeof resetTransform === 'function' && resetTransform();
                                                    }}
                                                />
                                            </div>
                                        )}
                                        </Zoom>
                                        
                                    </div>
                                );
                            })}
                        </Slider>
                    )}
                </Modal>
            </div> 
            :
            <div className="hidden 3_1sm:block">
                <Modal
                    // width="w-11/20 md:w-13/20 lg:w-14/20 xl:w-15/20"
                    width="3_1sm:w-[calc(100%_-_8rem)] w-[calc(100%_-_1rem)]"
                    contentClassName="rounded-lg overflow-auto custom-style"
                    wrapperClassName="overflow-visible custom-style my-0"
                    image_gallery={true}
                >
                    <div className="" ref={modalRef}>
                        <div className="flex flex-row items-baseline mb-1 gap-4">
                            <p className="text-lg text-white font-bold flex-1 truncate" title={currentImage?.file_name || currentImage?.title}>
                                {/* {media.length}{" "}
                                {media.length > 1 ? "Photos" : "Photo"} */}
                                 {currentIndex} of {totalPhotos || media.length}
                                <span className="text-lg text-white text-counter">{` - ${currentImage?.file_name || currentImage?.title}`}</span>
                            </p>
                            {/* <p className="text-lg text-white flex-1 flex justify-center">
                                {currentIndex} of {media.length}
                            </p> */}
                            {/* close */}
                            <div className="flex justify-end">
                                <button onClick={() => hide()} className="mr-4">
                                    <FaTimes className="text-white text-xl" />
                                </button>
                            </div>
                        </div>
                        <div className="w-full">
                            {button.url ? (
                                <Slider ref={sliderRef} {...settings}>
                                    <div className="bg-black">
                                        <img
                                            src={button.url}
                                            className="object-cove m-auto"
                                            style={{ maxHeight: `${modalHeight}px`, }}
                                            alt="slider"
                                        />
                                    </div>
                                </Slider>
                            ) : (
                                <Slider ref={sliderRef} {...settings}>
                                    {media.map((file, index) => {
                                        return (
                                            <Zoom>
                                                {({resetTransform}) => (
                                                    <div className="w-[calc(88vw_-_2rem)] 1smd:w-[94vw] h-[calc(90vh_-_2rem)] 1smd:h-[95vh] flex">
                                                        <img
                                                            src={file.media.webp_url || file.media.url}
                                                            className="object-contain m-auto"
                                                            style={{ maxHeight: `${modalHeight}px`, opacity: 0, 
                                                                height:`${modalHeight}px`,
                                                                transition: 'all 0.3s 0.25s', 
                                                                userSelect: "none",
                                                                pointerEvents: "none"
                                                            }}
                                                            alt={`slider-${index}`}
                                                            draggable="false" 
                                                            onLoad={(e) => {
                                                                e.target.style.opacity = 1;
                                                                typeof resetTransform === 'function' && resetTransform();
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </Zoom>
                                        );
                                    })}
                                </Slider>
                            )}

                            {/* <div className="flex flex-row justify-center space-x-4 mt-4">
                                {media.map((file, index) => {
                                    let url = file.url
                                        ? file.url
                                        : file.media.webp_url || file.media.url;
                                    return (
                                        <div
                                            key={index}
                                            className="bg-black cursor-pointer"
                                            onClick={() => onChange(index)}
                                        >
                                            <img
                                                src={url}
                                                className="w-24 h-24 object-cover"
                                                alt={`preview-${index}`}
                                            />
                                        </div>
                                    );
                                })}
                            </div> */}
                        </div>
                    </div>
                </Modal>
            </div>
        }
            
            
        </>
    );
}
